export const types = {
  ON_OPEN_MODAL: 'ON_OPEN_MODAL',
  ON_CLOSE_MODAL: 'ON_CLOSE_MODAL',
};

export const onOpenModal = () => dispatch => dispatch( {
  type: types.ON_OPEN_MODAL,
} );

export const onCloseModal = () => dispatch => dispatch( {
  type: types.ON_CLOSE_MODAL,
} );



// WEBPACK FOOTER //
// ./src/actions/modal.js